import { render } from "./order_summary.vue?vue&type=template&id=484aa2f6&scoped=true"
import script from "./order_summary.vue?vue&type=script&lang=ts"
export * from "./order_summary.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-484aa2f6"

export default script